import usePermissions from "hooks/usePermissions";
const useHasTypeMappingPermission = () => {
  const { isPermitted } = usePermissions();
  return isPermitted("typemappings:edit");
};
export default useHasTypeMappingPermission;
